// extracted by mini-css-extract-plugin
export default {"container":"ExternalLink_container__lzIyI"};